import React, { lazy } from 'react';
import { Home, Droplets, Maximize, DoorOpen, Bath, Square, Layout, Grid } from 'lucide-react';
const SERVICES = [{
  title: 'Home Window Glass Repair',
  copy: 'Broken, cracked or shattered window glass repaired or replaced for single-pane, double-hung, casement, bay, bathroom and other home windows.',
  Icon: Home
}, {
  title: 'Foggy Double-Pane & Seal Repair',
  copy: "Fog or condensation between panes often means an insulated glass seal has failed. Kosin's Glass can inspect the unit and recommend repair or glass replacement.",
  Icon: Droplets
}, {
  title: 'Window Glass Replacement Only',
  copy: 'When your window frames are still in good condition, replacing the glass only can be a smart alternative to full replacement windows.',
  Icon: Maximize
}, {
  title: 'Door Glass & Glass Inserts',
  copy: 'Replacement glass for entry doors, patio doors, storm doors, interior door glass, decorative inserts and other residential door glass.',
  Icon: DoorOpen
}, {
  title: 'Custom Glass Shower Doors',
  copy: 'Frameless, semi-frameless, sliding, Euro-style shower doors and custom shower enclosures designed, measured and installed for your bathroom.',
  Icon: Bath
}, {
  title: 'Custom Mirrors',
  copy: 'Bathroom mirrors, vanity mirrors, wall mirrors, home gym mirrors, beveled mirrors, tinted mirrors, etched mirrors and custom-shaped mirrors.',
  Icon: Square
}, {
  title: 'Table Tops, Shelves & Decorative Glass',
  copy: 'Custom glass table tops, shelves, cabinet glass, patterned glass, etched glass, interior glass and specialty glass for home projects.',
  Icon: Layout
}, {
  title: 'Screens & Glass Deck Railings',
  copy: 'Window screen and door screen repair or replacement, plus custom glass panels for modern deck railings and outdoor views.',
  Icon: Grid
}];
export function Services() {
  return <section className="py-16 lg:py-24 px-4 sm:px-6 lg:px-8 bg-slate-50" data-id="element-1416">
      <div className="max-w-7xl mx-auto" data-id="element-1417">
        <div className="relative rounded-2xl overflow-hidden mb-14 shadow-card anim-on-scroll" data-id="element-1418">
          <img src="https://cdn.magicpatterns.com/uploads/h2qRQvUepuGGwekHwZfuZx/respic1.webp" alt="Bright residential living room with large home windows" className="w-full h-64 sm:h-80 lg:h-96 object-cover" loading="lazy" data-id="element-1419" />
          <div className="absolute inset-0 bg-black/50" aria-hidden="true" data-id="element-1420" />
          <div className="absolute inset-0 flex items-center" data-id="element-1421">
            <div className="px-6 sm:px-10 lg:px-14 max-w-2xl" data-id="element-1422">
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white tracking-tight mb-4" data-id="element-1423">
                Residential Glass Services for Every Room in Your Home
              </h2>
              <p className="text-lg text-slate-100 max-w-xl" data-id="element-1424">
                From broken home windows to custom shower glass, mirrors and
                table tops, Kosin's Glass repairs, replaces, designs and
                fabricates residential glass for homeowners across Southeast
                Michigan.
              </p>
            </div>
          </div>
        </div>
        <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12" data-id="element-1425">
          {SERVICES.map(({
          title,
          copy,
          Icon
        }, idx) => <li key={idx} className="bg-white rounded-2xl p-6 shadow-soft border border-slate-100 hover:shadow-card transition-shadow anim-on-scroll" data-id="element-1426">
              <div className="w-14 h-14 rounded-xl bg-glassBlue-50 flex items-center justify-center mb-6" data-id="element-1427">
                <Icon className="w-8 h-8 text-brandBlue-600" aria-hidden="true" data-id="element-1428" />
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-1429">{title}</h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-1430">{copy}</p>
            </li>)}
        </ul>
        <div className="text-center" data-id="element-1431">
          <a href="#estimate-form" className="inline-flex items-center justify-center bg-brandBlue-600 hover:bg-brandBlue-700 text-white font-bold text-lg py-4 px-8 rounded-xl transition-colors shadow-md" data-id="element-1432">
            Request a Free Residential Glass Estimate
          </a>
        </div>
      </div>
    </section>;
}